var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0455 8.14698L10.091 11.1811V1.50928H2V11.1811L6.0455 8.14698ZM1.11617 0.00927734H10.9748C11.1382 0.00927734 11.295 0.0741947 11.4105 0.189748C11.5261 0.305302 11.591 0.462026 11.591 0.625444V12.9488C11.591 13.0632 11.5591 13.1754 11.499 13.2727C11.4388 13.3701 11.3527 13.4487 11.2504 13.4999C11.148 13.5511 11.0335 13.5727 10.9195 13.5625C10.8055 13.5522 10.6967 13.5104 10.6051 13.4417L6.0455 10.022L1.48587 13.4417C1.39432 13.5104 1.28547 13.5522 1.1715 13.5625C1.05753 13.5727 0.942958 13.5511 0.840609 13.4999C0.73826 13.4487 0.652183 13.3701 0.592024 13.2727C0.531865 13.1754 0.5 13.0632 0.5 12.9488V0.625444C0.5 0.462026 0.564917 0.305302 0.680471 0.189748C0.796025 0.0741947 0.952749 0.00927734 1.11617 0.00927734Z",
    fill: "#FDCF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.084da9cca385fc675ade8ceac544f1ca.svg";
export { ForwardRef as ReactComponent };